import React, { useEffect } from 'react';
import Logo from './Logo';
import { STYLES } from '../consts/consts';

export interface ILogo {
    id: string;
    name: string;
    isDefault: boolean;
}

interface IProps {
    items: ILogo[],
    selectedItems: string[],
    setSelectedItems: (data: string[]) => void;
    maxSelection?: number;
    isCustomLogoMode?: boolean;
    isCustomLogoSet?: boolean;
    preSelectLogoId?: string;
    triggerInitialSelect?: boolean;
}

export const LogoList = ({
  items, setSelectedItems, maxSelection, selectedItems, isCustomLogoMode, isCustomLogoSet, preSelectLogoId, triggerInitialSelect,
}: IProps) => {
  const getInitialSelection = () => {
    const selectedIdArray: string[] = [];
    if (preSelectLogoId) {
      const preSelectLogo = items.filter((i: ILogo) => i.id === preSelectLogoId)[0];
      selectedIdArray.push(preSelectLogo.id);
      return selectedIdArray;
    }
    items.forEach((item) => {
      if (item.isDefault) {
        selectedIdArray.push(item.id);
      }
    });
    if (selectedIdArray.length > 0) return selectedIdArray;
    return [items[0].id];
  };

  const getItemIdxById = (itemId:string) => selectedItems.findIndex(id => id === itemId);

  const handleItemSelection = (id: string) => {
    if (maxSelection && maxSelection > 1) {
      const itemIdx = getItemIdxById(id);
      if (itemIdx === -1) {
        if (selectedItems.length === maxSelection) {
          return;
        }
        const newState = [...selectedItems, id];
        setSelectedItems(newState);
      } else {
        const updatedList = [...selectedItems];
        updatedList.splice(itemIdx, 1);
        setSelectedItems(updatedList);
      }
    } else {
      const newState = [id];
      setSelectedItems(newState);
    }
  };

  useEffect(() => {
    if (isCustomLogoMode && !isCustomLogoSet) {
      setSelectedItems(getInitialSelection());
    }
  }, [isCustomLogoSet]);

  useEffect(() => {
    if (triggerInitialSelect) {
      setSelectedItems(getInitialSelection());
    }
  }, [triggerInitialSelect]);

  useEffect(() => {
    setSelectedItems(getInitialSelection());
  }, []);

  return (
    <div className={STYLES.PAGES.LOGO.LOGO_LIST_WRAPPER}>
      {items.map(item => <Logo key={item.id} handleOnClick={() => handleItemSelection(item.id)} item={item} isSelected={!isCustomLogoMode && selectedItems.includes(item.id)} />)}
    </div>
  );
};
